import Common from '../../Common';

interface Body {
	entityId: string
	login_url: string
	logout_url: string
	certificate: string
}

const SAML = class extends Common {
	read = (companyId: id): CustomResponse<SAML> =>
		this.get(`/company/${companyId}/saml`)
	update = (companyId: id, body: Body) =>
		this.patch(`/company/${companyId}/saml`, body)
	delete = (companyId: id) =>
		this.doDelete(`/company/${companyId}/saml`)
}

export default SAML
